//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext,  useContext, useState, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Paper,
  TableContainer,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
} from '@mui/material';

// === UTILS ===
import { regex_start_of_word, spaceBeforeWord } from 'components/utils';

import { SchedulerContext } from '../SchedulerContext/SchedulerContext';

//#endregion

//-----------------------------------------------------------------
export function SchedulerTable() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  const { 
    schedule_data,
    is_loading   ,
    selected     , setSelected  ,
  } = useContext( SchedulerContext );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {

    },
    header: {
      padding: '0.5rem',
    },
    loading: {  
      display    : is_loading ? '' : 'none'   ,    
      color      : theme.palette.primary.main ,
      position   : 'absolute' ,
      top        : '50%'      ,
      left       : '50%'      ,
      marginTop  : -12        ,
      marginLeft : -12        ,
    }
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      component: Paper,
    },
    HEADER = {
      sx       : _styles.header  ,
      variant  : 'h5'            ,
      // children : [ report_name ] ,
    },
    REPORT = {
      size: 'small',
    },
    REPORT_COLUMNS = {
      children: [ displayHeaders() ],
    },
    REPORT_DATA = {
      children: [ displayData() ],
    },
    LOADING = {
      sx   : _styles.loading,
      size : 50,
    };

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if ( schedule_data.length <= 0 ) return <CircularProgress { ...LOADING } />;

    return (
      <TableContainer { ...CONTAINER } >
        <Typography { ...HEADER } />
        <Table { ...REPORT }>
          <TableHead { ...REPORT_COLUMNS } />
          <TableBody { ...REPORT_DATA    } />
        </Table>        
      </TableContainer>
    );
  }

  function displayHeaders() {
    return (
        <TableRow>
          <TableCell key={0}>{ 'Batch Name'    }</TableCell>
          <TableCell key={1}>{ 'Start Date'    }</TableCell>
          <TableCell key={2}>{ 'Time'          }</TableCell>
          <TableCell key={3}>{ 'Frequency'     }</TableCell>
          <TableCell key={4}>{ 'Recipients'    }</TableCell>
        </TableRow>
      )
  }

  //-----------------------------------------------------------------
  function displayData() {
    //-----------------------------------------------------------------
    if ( schedule_data.length <= 0 ) return null;

    try {
      const result = [];
  
      schedule_data.forEach((row, index) => {
        const is_selected = selected === row.id;
        const recipients = row.recipients.map( x => x.Username).join( ', ');
        result.push(
          <TableRow key={index} id={index} selected={is_selected} onClick={ () => {
            if( is_selected ) setSelected( null );
            else              setSelected(row.id);
            } }>
            <TableCell key={0}>{ row.report_name }</TableCell>
            <TableCell key={1}>{ row.start_date  }</TableCell>
            <TableCell key={2}>{ row.time        }</TableCell>
            <TableCell key={3}>{ row.frequency   }</TableCell>
            <TableCell key={4}>{     recipients  }</TableCell>
          </TableRow>
        );
      });
  
      return result;
    } catch (error) {
      console.warn( error );
    }

    return <div>Error</div>
  };

  //#endregion

  return display();
}